import React from 'react';
import { Header, Icon, Loader, Popup, Segment } from 'semantic-ui-react';
import axios from 'axios';
import download from 'downloadjs';
import 'react-widgets/dist/css/react-widgets.css';
import { ToastContainer, toast } from 'react-toastify';

// mock
import * as mock2 from './mockv2';
import FilterForm from './FilterForm';
import FilterFormSS from './FilterFormSS';
import Options from './Options';
import DataTable from './DataTable';
import DataTableSS from './DataTableSS';
import AfterPrint from './AfterPrint';

import {
    extractFileNameFromHeaders, buildFilterParamsObject,
    buildPrintOptionFiltersParamsObject
} from './util/util';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { IconHeader } from '../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

// FIXME: lookup fetching requires pagination params
// FIXME: enter press on input field rerenders initial component state
const PAGINATION_PARAMS = {
    name: '',
    pageNumber: 0,
    resultsPerPage: 1000,
};

export default class Wizard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loader: false,
            error: false,
            errorText: '',
            wizardStep: 0,
            data: [],
            selectedData: [],
            languages: [],
            filtersSelectedValues: {
                graduated: true,
                locked: false,
                organizationalUnit: null,
                studyCycle: null,
                startDate: new Date(new Date().getFullYear(), 0, 1),
                endDate: new Date(),
                firstName: '',
                lastName: '',
                documentNumber: '',
            },
            filtersAvailableValuesList: {
                organizationalUnits: [],
                studyCycles: [],
            },
            printOptionsFiltersSelectedValues: {
                issueDate: new Date(),
                documentType: '',
                documentReason: '',
                language: '',
                withLogo: true
            },
            printOptionsFiltersAvailableValuesList: {
                documentTypes: [],
                documentReasons: [],
                languages: []
            },
            afterPrintRequest: {
                success: null,
            },

            organizationalUnitErr: false,
            studyCycleErr: false,
            excelData: []

        };
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onPrintOptionsFilterChange = this.onPrintOptionsFilterChange.bind(this);
        this.changeWizardStep = this.changeWizardStep.bind(this);
        this.handleNewFilterSubmit = this.handleNewFilterSubmit.bind(this);
        this.clearAllFilters = this.clearAllFilters.bind(this);
        this.onDataChange = this.onDataChange.bind(this);
        this.requestPrint = this.requestPrint.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.resetOrClearFilterFormDates = this.resetOrClearFilterFormDates.bind(this);
    }

    // TODO: check for empty responses
    // componentWillMount() {
    //     // TODO: once these are all axios calls, move them to componentDidMount
    //     this.setState({
    //         printOptionsFiltersAvailableValuesList: {
    //             ...this.state.printOptionsFiltersAvailableValuesList,
    //             languages: this.state.languages,
    //         },
    //         printOptionsFiltersSelectedValues: {
    //             ...this.state.printOptionsFiltersSelectedValues,
    //             language: this.state.language,
    //         }
    //     });
    // }
    componentDidMount() {
        // fetch study-cycles
        axios.get('/study-cycles', { params: PAGINATION_PARAMS })
            .then(res => {
                this.setState({
                    filtersAvailableValuesList: {
                        ...this.state.filtersAvailableValuesList,
                        studyCycles: res.data.map(el => ({
                            ...el, key: el.id, value: el.id, text: el.displayName
                        }))
                    },
                    filtersSelectedValues: {
                        ...this.state.filtersSelectedValues,
                        studyCycle: '',
                    },
                    loading: false
                });
            }).catch(err => this.setState({ error: true, errorText: 'failed to fetch studyCycles' }));

        // fetch faculties
        axios.get('/graduation-documents/faculties')
            .then(res => {
                this.setState({
                    filtersAvailableValuesList: {
                        ...this.state.filtersAvailableValuesList,
                        organizationalUnits: res.data.map(el => ({
                            ...el, key: el.id, value: el.id, text: el.name
                        }))
                    },
                    filtersSelectedValues: {
                        ...this.state.filtersSelectedValues,
                        organizationalUnit: '',
                    },
                    loading: false

                });
            }).catch(err => this.setState({ error: true, errorText: 'failed to fetch faculties' }));


        // fetch document-types and document reasons based on document types
        axios.get('/document-types/graduation', { params: PAGINATION_PARAMS })
            .then(res => {
                if (!this.props.sService) {
                    axios.get('/document-reasons/get-reasons/' + res.data[0].id)
                        .then(res2 => {
                            if (res2.data.length === 0) {
                                this.setState({ error: true, errorText: 'documentReasons list was empty' });
                                return;
                            }

                            this.setState({
                                printOptionsFiltersAvailableValuesList: {
                                    ...this.state.printOptionsFiltersAvailableValuesList,
                                    documentReasons: res2.data.map(el => ({
                                        ...el, key: el.id, value: el.id, text: el.name
                                    }))
                                }
                            });
                            this.setState({
                                printOptionsFiltersSelectedValues: {
                                    ...this.state.printOptionsFiltersSelectedValues,
                                    documentReason: res2.data[0].id
                                }
                            });
                            this.setState({
                                printOptionsFiltersAvailableValuesList: {
                                    ...this.state.printOptionsFiltersAvailableValuesList,
                                    documentTypes: res.data.map(el => ({
                                        ...el, key: el.id, value: el.id, text: el.name
                                    })).filter(e => e.name !== 'Uvjerenje o završenom ciklusu studija')
                                },
                                printOptionsFiltersSelectedValues: {
                                    ...this.state.printOptionsFiltersSelectedValues,
                                    documentType: res.data[0].id
                                }
                            });

                            axios.get('/languages')
                                .then(res1 => {
                                    this.setState({
                                        printOptionsFiltersAvailableValuesList: {
                                            ...this.state.printOptionsFiltersAvailableValuesList,
                                            languages: res1.data.filter(e => e.twoLetterCode === 'bs' || e.twoLetterCode === 'en').map(el => ({
                                                ...el, key: el.id, value: el.id, text: el.name
                                            }))
                                        }
                                    });

                                    this.setState({
                                        printOptionsFiltersSelectedValues: {
                                            ...this.state.printOptionsFiltersSelectedValues,
                                            language: res1.data[0].id
                                        }
                                    });
                                }).catch(err => this.setState({ error: true, errorText: 'failed to fetch languages' }));
                        }).catch(err => this.setState({
                            error: true,
                            errorText: `failed to fetch document reasons for document type ${res.data[0].id}`
                        }));
                }
            })
            .catch(err => this.setState({ error: true, errorText: 'failed to fetch document types' }));
    }

    onFilterChange(filterName, filterValue) {
        const { filtersSelectedValues } = this.state;
        // if organizationalUnit or studyCycle is changed, empty selectedData
        if (filterName === 'organizationalUnit' || filterName === 'studyCycle') this.setState({ selectedData: [] });

        this.setState({ filtersSelectedValues: { ...filtersSelectedValues, [filterName]: filterValue } });
    }

    onPrintOptionsFilterChange(filterName, filterValue) {
        // this.setState({ [filterName]: filterValue });
        const { printOptionsFiltersSelectedValues } = this.state;
        // if (filterName === 'documentType') {
        //     // update documentReasonList and set value on first id
        //     axios.get('/document-reasons/get-reasons/' + filterValue)
        //         .then(res => {
        //             this.setState({
        //                 printOptionsFiltersAvailableValuesList: {
        //                     ...printOptionsFiltersAvailableValuesList,
        //                     documentReasons: [...res.data.map(el => ({
        //                         ...el, key: el.id, value: el.id, text: el.name
        //                     }))]
        //                 }
        //             });
        //             this.setState({
        //                 printOptionsFiltersSelectedValues:
        //             { ...printOptionsFiltersSelectedValues, documentReason: res.data[0].id, documentType: filterValue }
        //             });
        //         })
        //         .catch(err => this.setState({ error: true, errorText: 'failed to update document reasons' }));
        // } else
        this.setState({ printOptionsFiltersSelectedValues: { ...printOptionsFiltersSelectedValues, [filterName]: filterValue } });
    }

    onDataChange(row) {
        // TODO: filtering doesn't need to happen on both sides
        // if the row is present in selectedData remove it, otherwise add it
        const pos = this.state.selectedData.findIndex(el => el.id === row.id);
        if (pos === -1) {
            // add to selectedData
            this.setState({ selectedData: [...this.state.selectedData, row] });
        } else {
            // remove from selectedData
            const newSelectedData = this.state.selectedData.filter(el => el.id !== row.id);
            this.setState({ selectedData: newSelectedData });
        }
    }
    resetOrClearFilterFormDates(action) {
        const { filtersSelectedValues } = this.state;
        if (action === 'reset') {
            this.setState({ filtersSelectedValues: { ...filtersSelectedValues, startDate: new Date(new Date().getFullYear(), 0, 1), endDate: new Date() } });
        } else {
            this.setState({ filtersSelectedValues: { ...filtersSelectedValues, startDate: null, endDate: null } });
        }
    }

    clearAllFilters() {
        const { printOptionsFiltersAvailableValuesList } = this.state;

        this.setState({
            filtersSelectedValues: {
                graduated: true,
                locked: false,
                organizationalUnit: '',
                studyCycle: '',
                startDate: new Date(new Date().getFullYear(), 0, 1),
                endDate: new Date(),
                firstName: '',
                lastName: '',
                documentNumber: '',
            },
            organizationalUnitErr: false,
            studyCycleErr: false,

        });

        if (!this.props.admin && !this.props.sService) {
            this.setState({
                printOptionsFiltersSelectedValues: {
                    issueDate: new Date(),
                    documentType: printOptionsFiltersAvailableValuesList.documentTypes[0].id,
                    documentReason: printOptionsFiltersAvailableValuesList.documentReasons[0].id,
                    language: printOptionsFiltersAvailableValuesList.languages[0].id
                }
            });
        }
    }

    handleNewFilterSubmit() {
        // creates a object with all params
        let params = buildFilterParamsObject(this.state.filtersSelectedValues);
        this.setState({ loader: true });

        axios.post(`/graduation-documents/${this.state.filtersSelectedValues.organizationalUnit}`, { ...params })
            .then(res => {
                this.setState({
                    data: res.data.map(el => ({
                        ...el,
                        date: moment(el.dateOfGraduation).format('D. M. YYYY.'),
                        department: el.departmentsSPOU[0] ? el.departmentsSPOU[0].organizationalUnitName : '',
                    }))
                });
                const excelData = res.data.map(el => ([
                    { value: el.lastName },
                    { value: el.fatherName },
                    { value: el.firstName },
                    { value: el.departmentsSPOU[0] ? el.departmentsSPOU[0].organizationalUnitName : '' },
                    { value: el.studyProgramBasicName },
                    { value: el.studyProgramName },
                    { value: el.documentNumber },
                    { value: el.indexNumber },
                    { value: moment(el.dateOfGraduation).format('D. M. YYYY.'), },
                    { value: el.title },
                ]));
                this.setState({ excelData });
                this.setState({ loader: false });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch graduation documents');
            });
    }
    requestPrint() {
        // TODO: append faculty id to request
        const ids = this.state.selectedData.map(e => e.id);
        if (ids.length === 0) return;
        const { organizationalUnit, studyCycle } = this.state.filtersSelectedValues;
        const params = buildPrintOptionFiltersParamsObject({
            ...this.state.printOptionsFiltersSelectedValues, ids, facultyId: organizationalUnit, studyCycle, languages: this.state.printOptionsFiltersAvailableValuesList.languages, withLogo: this.state.printOptionsFiltersSelectedValues.withLogo
        });
        axios({
            method: 'post',
            url: '/graduation-documents/print',
            responseType: 'blob',
            data: { ...params }
        })
            .then(res => {
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })

            .then(res => this.setState({ afterPrintRequest: { success: true } }))
            .catch(err => this.setState({ error: true, errorText: 'failed to download documents' }));
    }
    changeWizardStep(direction) {
        const { wizardStep } = this.state;
        if (direction === 'prev') {
            if (wizardStep === 0) return;
            if (this.props.admin || this.props.sService) { this.setState({ wizardStep: wizardStep - 2 }); } else { this.setState({ wizardStep: wizardStep - 1 }); }
        }
        if (direction === 'next') {
            // filter case
            if (wizardStep === 0) {
                this.onFilterChange('', '');
                if (!this.props.sService && (!this.state.filtersSelectedValues.organizationalUnit || !this.state.filtersSelectedValues.studyCycle)) {
                    toast('Niste unijeli sva obavezna polja!');
                    if (!this.state.filtersSelectedValues.organizationalUnit) {
                        this.setState({ organizationalUnitErr: true });
                    } else { this.setState({ organizationalUnitErr: false }); }
                    if (!this.state.filtersSelectedValues.studyCycle) {
                        this.setState({ studyCycleErr: true });
                    } else { this.setState({ studyCycleErr: false }); }
                    this.setState({ wizardStep: 0 });
                } else if (this.props.sService && !this.state.filtersSelectedValues.studyCycle) {
                    toast('Niste unijeli sva obavezna polja!');
                    if (!this.state.filtersSelectedValues.studyCycle) {
                        this.setState({ studyCycleErr: true });
                    } else { this.setState({ studyCycleErr: false }); }
                    this.setState({ wizardStep: 0 });
                } else {
                    this.setState({ studyCycleErr: false, organizationalUnitErr: false });
                    this.handleNewFilterSubmit();
                    if (this.props.admin || this.props.sService) { this.setState({ wizardStep: wizardStep + 2 }); } else { this.setState({ wizardStep: wizardStep + 1 }); }
                }
            }

            if (wizardStep === 1) {
                this.setState({ wizardStep: wizardStep + 1 });
            }
            // print case
            if (wizardStep === 2) {
                // if nothing is selected, dont proceed
                if (this.state.selectedData.length === 0) {
                    toast('Morate označiti bar jednog studenta.');
                    return;
                }
                this.requestPrint();
                this.setState({ wizardStep: wizardStep + 1 });
            }
            if (wizardStep === 3) {
                // after success clear data & selectedData
                if (this.state.afterPrintRequest.success) {
                    // this.setState({ selectedData: [], data: [] });
                }
                // changeWizardStep to 0
                this.setState({ wizardStep: 0 });
            }
        }
    }

    selectAll() {
        const { data, selectedData } = this.state;
        // deselect all if data.length === selectedData.length
        if (selectedData.length === data.length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: this.state.data });
        }
    }

    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        const { wizardStep } = this.state;
        return (
            <div>
                <Header as="h1">{this.props.admin ? 'Diplomirani studenti' : this.props.sService ? '' : 'Štampanje diploma'}</Header>
                {wizardStep === 0 ?
                    this.props.sService ?
                        <FilterFormSS
                            filtersSelectedValues={this.state.filtersSelectedValues}
                            filtersAvailableValuesList={this.state.filtersAvailableValuesList}
                            onFilterChange={this.onFilterChange}
                            resetOrClearFilterFormDates={this.resetOrClearFilterFormDates}
                            organizationalUnitErr={this.state.organizationalUnitErr}
                            studyCycleErr={this.state.studyCycleErr}
                            changeWizardStep={this.changeWizardStep}
                            clearAllFilters={this.clearAllFilters}
                        />
                        : <FilterForm
                            filtersSelectedValues={this.state.filtersSelectedValues}
                            filtersAvailableValuesList={this.state.filtersAvailableValuesList}
                            onFilterChange={this.onFilterChange}
                            resetOrClearFilterFormDates={this.resetOrClearFilterFormDates}
                            organizationalUnitErr={this.state.organizationalUnitErr}
                            studyCycleErr={this.state.studyCycleErr}
                            changeWizardStep={this.changeWizardStep}
                            clearAllFilters={this.clearAllFilters}
                        /> :
                    wizardStep === 1 ?
                        <Options
                            printOptionsFiltersSelectedValues={this.state.printOptionsFiltersSelectedValues}
                            printOptionsFiltersAvailableValuesList={this.state.printOptionsFiltersAvailableValuesList}
                            onPrintOptionsFilterChange={this.onPrintOptionsFilterChange}
                            changeWizardStep={this.changeWizardStep}
                        /> :
                        wizardStep === 2 ?
                            this.props.sService ? <DataTableSS
                                data={this.state.data}
                                selectedData={this.state.selectedData}
                                onDataChange={this.onDataChange}
                                selectAll={this.selectAll}
                                changeWizardStep={this.changeWizardStep}
                                excelData={this.state.excelData}
                                loader={this.state.loader}
                            />
                                : <Segment.Group raised><Segment clearing>
                                    <Header as="h3">
                                        <Header.Content>
                                            Spisak studenata
                                        </Header.Content>
                                        <Header style={IconHeader} floated="right" >
                                            <Icon />
                                            <Popup
                                                trigger={<Icon
                                                    link
                                                    circular
                                                    basic="true"
                                                    floated="right"
                                                    name="arrow left"
                                                    onClick={() => this.changeWizardStep('prev')}
                                                />}
                                                content="Nazad"
                                                hideOnScroll
                                                position="top center"
                                            />
                                        </Header>
                                    </Header>
                                    {/* <h3>Spisak studenata</h3> */}
                                </Segment>
                                    <Segment clearing>
                                    <DataTable
                                        data={this.state.data}
                                        selectedData={this.state.selectedData}
                                        onDataChange={this.onDataChange}
                                        selectAll={this.selectAll}
                                        changeWizardStep={this.changeWizardStep}
                                        admin={this.props.admin}
                                        printOptionsFiltersSelectedValues={this.state.printOptionsFiltersSelectedValues}
                                        printOptionsFiltersAvailableValuesList={this.state.printOptionsFiltersAvailableValuesList}
                                        /></Segment></Segment.Group>
                            : wizardStep === 3 ?
                                <AfterPrint
                                    success={this.state.afterPrintRequest.success}
                                    changeWizardStep={this.changeWizardStep}
                                /> : null
                }
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/DegreeDocumentPrint/Wizard.js